import { useStatsigClient } from '@statsig/react-bindings';

import { FEATURE_FLAGS } from '@/enums/FeatureFlags';

export const useFeatureFlag = () => {
  const client = useStatsigClient();
  return {
    isFFEnabled: (key: FEATURE_FLAGS) => {
      const value = client.checkGate(key.toString()) || false;
      return value;
    },
  };
};
